<script setup>
import { Link } from '@inertiajs/vue3';
import KeenLogo from '@/Components/KeenLogo.vue';

defineProps({
	light: {
		type: Boolean,
		default: false,
	},
	withWordmark: {
		type: Boolean,
		default: false,
	},
	isCollapsed: {
		type: Boolean,
		default: false,
	},
	tile: {
		type: Boolean,
		default: false,
	},
});

</script>

<template>
  <Link :href="route('index')">
    <span
      data-testid="application-logo"
      class="flex items-center transition-opacity duration-slow"
      :class="light ? 'text-brand-light' : 'text-brand-dark dark:text-brand-muted'"
    >
      <KeenLogo
        variant="tile"
        data-testid="application-logo-symbol"
        class="w-auto h-8"
        :class="isCollapsed ? '' : 'lg:hidden lg:group-[&.collapsed]/wrapper:block'"
      />
      <KeenLogo
        v-if="!isCollapsed"
        variant="wordmark"
        data-testid="application-logo-wordmark"
        class="hidden w-auto h-6 lg:block lg:group-[&.collapsed]/wrapper:hidden"
      />
    </span>
  </Link>
</template>
